import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SectionWrapperComponent } from '../containers/section-wrapper-container/section-wrapper-container.component';
import { TranslocoModule } from '@ngneat/transloco';
import { SummaryItemComponent } from 'shared/components/summary-item/summary-item.component';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { IDENTITY_DOCUMENT_TYPES } from '../../../modules/admin/staff/translations/staff-select-items';
import { GetTranslationKeyForValuePipe } from '../dropdowns/filter-multiselect-dropdown/get-translation-key-for-value.pipe';
import { CountryNamePipe } from '../../pipes/country-name.pipe';

@Component({
	selector: 'app-driver-overview-card',
	templateUrl: 'driver-overview-card.component.html',
	imports: [
		MatIconModule,
		SectionWrapperComponent,
		TranslocoModule,
		SummaryItemComponent,
		DatePipe,
		GetTranslationKeyForValuePipe,
		NgTemplateOutlet,
		CountryNamePipe,
	],
	standalone: true,
})
export class DriverOverviewCardComponent<T> {
	recordData = input<T>();
	idTypes = IDENTITY_DOCUMENT_TYPES;
}
